{
  "entry": {
    "title": "บันทึกคำสั่ง",
    "subtitle": "ระบบบันทึกคำสั่งโดยผู้ให้บริการด้วยคอมพิวเตอร์ (CPOE)",
    "searchSection": {
      "title": "ค้นหาและเพิ่มคำสั่ง",
      "cosignNotice": "คำสั่งของคุณต้องการการลงนามร่วมจากแพทย์ผู้รับผิดชอบก่อนเริ่มดำเนินการ"
    },
    "pending": {
      "title": "คำสั่งรอส่ง",
      "clearAll": "ล้างทั้งหมด",
      "collapseAria": "ย่อรายละเอียด",
      "expandAria": "ขยายรายละเอียด",
      "removeAria": "ลบคำสั่ง",
      "startDateTime": "วันที่/เวลาเริ่มต้น",
      "ariaStartDate": "วันที่เริ่มคำสั่ง",
      "ariaStartTime": "เวลาเริ่มคำสั่ง",
      "clinicalIndication": "ข้อบ่งชี้ทางคลินิก",
      "clinicalIndicationPlaceholder": "เหตุผลในการสั่ง…",
      "specialInstructions": "คำแนะนำพิเศษ",
      "specialInstructionsPlaceholder": "คำแนะนำเพิ่มเติมสำหรับหน่วยปฏิบัติงาน…",
      "diagnosisLabel": "การวินิจฉัย (ICD-10)",
      "diagnosisPlaceholder": "ค้นหารหัสวินิจฉัย ICD-10…",
      "noActiveEncounter": "ไม่มีการเข้ารับบริการที่ใช้งานอยู่ — ไม่สามารถสั่งได้",
      "placing": "กำลังส่ง…",
      "placeAll": "ส่งคำสั่งทั้งหมด ({{count}})"
    },
    "active": {
      "title": "คำสั่งที่ใช้งานอยู่",
      "loading": "กำลังโหลดคำสั่ง…",
      "emptyAll": "ไม่พบคำสั่งสำหรับผู้ป่วยรายนี้",
      "emptyFiltered": "ไม่พบคำสั่ง{{type}}",
      "columns": {
        "orderNumber": "เลขที่คำสั่ง",
        "name": "ชื่อ",
        "type": "ประเภท",
        "priority": "ความสำคัญ",
        "status": "สถานะ",
        "orderedBy": "ผู้สั่ง",
        "orderedDate": "วันที่สั่ง",
        "actions": "การดำเนินการ"
      },
      "external": "ภายนอก",
      "externalTitle": "คำสั่งภายนอกจาก {{source}}",
      "externalTitleWithId": "คำสั่งภายนอกจาก {{source}} (#{{id}})",
      "providerPlaceholder": "ผู้ให้บริการ #{{id}}",
      "actions": {
        "complete": "เสร็จสิ้น",
        "cancel": "ยกเลิก",
        "completeTooltip": "ทำคำสั่งให้เสร็จสิ้น",
        "cancelTooltip": "ยกเลิกคำสั่ง"
      }
    },
    "cancelDialog": {
      "title": "ยกเลิกคำสั่ง",
      "prompt": "โปรดระบุเหตุผลในการยกเลิก {{orderName}}",
      "placeholder": "เหตุผลในการยกเลิก (จำเป็น)…",
      "goBack": "ย้อนกลับ",
      "confirm": "ยืนยันการยกเลิก"
    },
    "toast": {
      "cancelSuccess": "ยกเลิกคำสั่งเรียบร้อยแล้ว",
      "cancelError": "ไม่สามารถยกเลิกคำสั่งได้",
      "completeSuccess": "ทำเครื่องหมายคำสั่งว่าเสร็จสิ้นแล้ว",
      "completeError": "ไม่สามารถทำคำสั่งให้เสร็จสิ้นได้",
      "noActiveEncounter": "ไม่พบการเข้ารับบริการที่ใช้งานอยู่สำหรับผู้ป่วยรายนี้ โปรดสร้างการเข้ารับบริการก่อน",
      "placedSuccess_one": "ส่งคำสั่ง {{count}} รายการเรียบร้อยแล้ว",
      "placedSuccess_other": "ส่งคำสั่ง {{count}} รายการเรียบร้อยแล้ว",
      "medicationFieldsRequired_one": "{{names}} ต้องระบุขนาดยา วิถีทางให้ยา และความถี่ก่อนสั่งจ่าย",
      "medicationFieldsRequired_other": "ยา {{count}} รายการต้องระบุขนาดยา วิถีทางให้ยา และความถี่: {{names}}",
      "medicationNotInFormulary_one": "{{names}} ไม่ได้เชื่อมกับบัญชียาและไม่สามารถตรวจสอบการแพ้ ปฏิกิริยา หรือขนาดยาได้ — สั่งจ่ายจากหน้ายา",
      "medicationNotInFormulary_other": "ยา {{count}} รายการไม่ได้เชื่อมกับบัญชียาและตรวจสอบไม่ได้: {{names}} — สั่งจ่ายจากหน้ายา",
      "placedError_one": "ส่งคำสั่ง {{count}} รายการไม่สำเร็จ",
      "placedError_other": "ส่งคำสั่ง {{count}} รายการไม่สำเร็จ",
      "orderSetApplied": "เพิ่มคำสั่ง {{count}} รายการจาก {{name}} — ตรวจสอบก่อนลงนาม"
    }
  },
  "catalog": "รายการคำสั่ง",
  "orderedBy": "สั่งโดย",
  "orderedDate": "วันที่สั่ง",
  "scheduledDate": "วันที่นัดหมาย",
  "completedDate": "วันที่เสร็จสิ้น",
  "lab": "ห้องปฏิบัติการ",
  "imaging": "ภาพวินิจฉัย",
  "medication": "ยา",
  "procedure": "หัตถการ",
  "consultation": "การปรึกษา",
  "priority": {
    "label": "ความเร่งด่วน",
    "values": {
      "stat": "STAT",
      "asap": "ASAP",
      "urgent": "ด่วน",
      "routine": "ปกติ",
      "scheduled": "ตามนัด",
      "prn": "PRN"
    }
  },
  "status": {
    "label": "สถานะคำสั่ง",
    "values": {
      "draft": "ร่าง",
      "pending": "รอดำเนินการ",
      "pendingCosign": "รอลงนามร่วม",
      "signed": "ลงนามแล้ว",
      "sent": "ส่งแล้ว",
      "active": "ใช้งานอยู่",
      "ordered": "สั่งแล้ว",
      "inProgress": "กำลังดำเนินการ",
      "holdForVerify": "รอตรวจสอบ",
      "completed": "เสร็จสิ้น",
      "cancelled": "ยกเลิกแล้ว",
      "discontinued": "หยุดใช้",
      "archived": "เก็บถาวรแล้ว",
      "pendingClarification": "รอการชี้แจง",
      "suspended": "ระงับ",
      "unknown": "ไม่ทราบ"
    }
  },
  "entryFields": {
    "searchPlaceholder": "ค้นหาคำสั่ง (แล็บ ภาพ ยา หัตถการ)…",
    "frequency": "ความถี่",
    "dose": "ขนาดยา",
    "route": "ทางให้ยา",
    "indication": "ข้อบ่งใช้",
    "duration": "ระยะเวลา",
    "comments": "หมายเหตุ",
    "signOrder": "ลงนามคำสั่ง",
    "holdOrder": "พักคำสั่ง",
    "frequencyOptions": {
      "stat": "STAT",
      "prn": "PRN",
      "bid": "BID",
      "tid": "TID",
      "qid": "QID",
      "qd": "QD",
      "qhs": "QHS",
      "ac": "AC",
      "pc": "PC"
    }
  },
  "catalogPage": {
    "title": "รายการคำสั่ง",
    "searchPlaceholder": "ค้นหาตามชื่อ รหัส หรือคำพ้อง…",
    "categories": "หมวดหมู่",
    "favorites": "รายการโปรด",
    "recentlyUsed": "ใช้ล่าสุด",
    "restricted": "รายการจำกัด",
    "searchCatalog": "ค้นหาในรายการ",
    "tabs": {
      "all": "ทั้งหมด",
      "lab": "แล็บ",
      "imaging": "ภาพ",
      "medication": "ยา",
      "procedure": "หัตถการ",
      "consultation": "ปรึกษา"
    },
    "columns": {
      "orderName": "ชื่อคำสั่ง",
      "code": "รหัส",
      "category": "หมวดหมู่",
      "description": "รายละเอียด",
      "defaultPriority": "ความเร่งด่วนเริ่มต้น"
    },
    "details": {
      "orderCode": "รหัสคำสั่ง",
      "category": "หมวดหมู่",
      "defaultPriority": "ความเร่งด่วนเริ่มต้น",
      "status": "สถานะ",
      "cptCode": "รหัส CPT",
      "loincCode": "รหัส LOINC",
      "synonyms": "คำพ้อง",
      "description": "รายละเอียด",
      "active": "ใช้งานอยู่",
      "inactive": "ไม่ใช้งาน"
    },
    "loading": "กำลังโหลดรายการ…",
    "loadError": "ไม่สามารถโหลดรายการคำสั่งได้",
    "emptyResults": "ไม่พบคำสั่งที่ตรงกับเงื่อนไข",
    "pagination": "แสดง {{from}}-{{to}} จากทั้งหมด {{total}}",
    "pageIndicator": "หน้า {{page}} จาก {{totalPages}}",
    "favoriteAdd": "เพิ่มในรายการโปรด",
    "favoriteRemove": "นำออกจากรายการโปรด",
    "favoriteAdded": "เพิ่มในรายการโปรดแล้ว",
    "favoriteRemoved": "นำออกจากรายการโปรดแล้ว"
  },
  "cosign": {
    "title": "คิวลงนามร่วมคำสั่ง",
    "requiresCosign": "ต้องลงนามร่วม",
    "cosignedBy": "ผู้ลงนามร่วม",
    "cosignDeadline": "กำหนดลงนามร่วม",
    "queueEmpty": "ไม่มีคำสั่งที่ต้องลงนามร่วม",
    "pendingCount": "รอดำเนินการ {{count}} รายการ",
    "loading": "กำลังโหลดคิวลงนามร่วม…",
    "loadError": "ไม่สามารถโหลดคิวลงนามร่วมได้",
    "columns": {
      "patient": "ผู้ป่วย",
      "order": "คำสั่ง",
      "type": "ประเภท",
      "orderingProvider": "ผู้สั่ง",
      "priority": "ความเร่งด่วน",
      "orderedDate": "วันที่สั่ง",
      "action": "การดำเนินการ"
    },
    "actions": {
      "cosign": "ลงนามร่วม"
    },
    "toast": {
      "success": "ลงนามร่วมคำสั่งสำเร็จ",
      "error": "ลงนามร่วมคำสั่งล้มเหลว"
    },
    "cosigningAs": "ลงนามร่วมในนาม: {{name}}"
  },
  "sets": {
    "title": "ชุดคำสั่ง",
    "newOrderSet": "ชุดคำสั่งใหม่",
    "addItem": "เพิ่มรายการ",
    "requiredItem": "บังคับ",
    "optionalItem": "เลือกได้",
    "editMode": "โหมดแก้ไข",
    "published": "เผยแพร่แล้ว",
    "draft": "ร่าง",
    "archived": "เก็บถาวรแล้ว",
    "versionNotes": "หมายเหตุเวอร์ชัน",
    "createTitle": "สร้างชุดคำสั่งใหม่",
    "fields": {
      "name": "ชื่อ",
      "category": "หมวดหมู่",
      "specialty": "สาขา",
      "description": "รายละเอียด"
    },
    "placeholders": {
      "name": "เช่น ตรวจหาสาเหตุอาการเจ็บอก",
      "categorySelect": "เลือกหมวดหมู่…",
      "specialty": "เช่น เวชศาสตร์ฉุกเฉิน",
      "description": "รายละเอียดสั้น ๆ…",
      "search": "ค้นหาชุดคำสั่ง…"
    },
    "categories": {
      "chestPain": "เจ็บอก",
      "sepsis": "ภาวะติดเชื้อในกระแสเลือด",
      "postOp": "หลังผ่าตัด",
      "admission": "รับเข้านอน",
      "discharge": "จำหน่าย",
      "other": "อื่น ๆ"
    },
    "statusFilter": {
      "all": "ทุกสถานะ",
      "active": "ใช้งานอยู่",
      "draft": "ร่าง",
      "archived": "เก็บถาวรแล้ว"
    },
    "columns": {
      "name": "ชื่อ",
      "category": "หมวดหมู่",
      "specialty": "สาขา",
      "items": "จำนวนรายการ",
      "status": "สถานะ",
      "version": "เวอร์ชัน",
      "actions": "การดำเนินการ"
    },
    "itemColumns": {
      "seq": "ลำดับ",
      "type": "ประเภท",
      "item": "รายการ",
      "priority": "ความเร่งด่วน",
      "required": "บังคับ"
    },
    "itemTypes": {
      "order": "คำสั่ง",
      "sectionHeader": "หัวข้อส่วน",
      "instruction": "คำแนะนำ"
    },
    "actions": {
      "publish": "เผยแพร่",
      "archive": "เก็บถาวร",
      "cancel": "ยกเลิก",
      "create": "สร้าง",
      "removeItem": "เอารายการออก"
    },
    "loading": "กำลังโหลดชุดคำสั่ง…",
    "loadError": "ไม่สามารถโหลดชุดคำสั่งได้",
    "emptyResults": "ไม่พบชุดคำสั่ง",
    "expandLoading": "กำลังโหลดรายการ…",
    "expandEmpty": "ชุดคำสั่งนี้ยังไม่มีรายการ",
    "validationRequired": "ต้องกรอกชื่อ หมวดหมู่ และสาขา",
    "toast": {
      "created": "สร้างชุดคำสั่งแล้ว",
      "createError": "สร้างชุดคำสั่งล้มเหลว",
      "published": "เผยแพร่ชุดคำสั่งแล้ว",
      "publishError": "เผยแพร่ชุดคำสั่งล้มเหลว",
      "archived": "เก็บถาวรชุดคำสั่งแล้ว",
      "archiveError": "เก็บถาวรชุดคำสั่งล้มเหลว",
      "itemRemoved": "เอารายการออกแล้ว",
      "itemRemoveError": "เอารายการออกล้มเหลว"
    },
    "versionBadge": "v{{version}}"
  },
  "search": {
    "placeholder": "ค้นหาคำสั่ง (แล็บ ภาพ ยา หัตถการ)…",
    "noResults": "ไม่พบคำสั่งสำหรับ \"{{query}}\"",
    "categories": {
      "all": "ทั้งหมด",
      "lab": "แล็บ",
      "imaging": "ภาพ",
      "med": "ยา",
      "procedure": "หัตถการ",
      "consultation": "ปรึกษา"
    },
    "addAll": "เพิ่มทั้งหมด {{count}}"
  },
  "worklist": {
    "title": "รายการงานคำสั่ง",
    "countBadge": "คำสั่ง {{count}} รายการ",
    "loading": "กำลังโหลดคำสั่ง…",
    "loadError": "ไม่สามารถโหลดคำสั่งได้ โปรดลองอีกครั้ง",
    "empty": "ไม่มีคำสั่งตรงกับตัวกรองปัจจุบัน",
    "typeLabel": "ประเภทคำสั่ง",
    "allOption": "ทั้งหมด",
    "columns": {
      "patient": "ผู้ป่วย",
      "order": "คำสั่ง",
      "type": "ประเภท",
      "priority": "ความเร่งด่วน",
      "status": "สถานะ",
      "ordered": "วันที่สั่ง"
    }
  }
}
